import gql from 'graphql-tag';
import { CART_AMOUNTS_FRAGMENT } from '@/lib';

export const PROFILE_SHIPPING_OPTIONS_QUERY = gql`
  query ProfileShippingOptionsQuery($token: String!) {
    checkoutSession(token: $token) {
      cart {
        ...CartAmounts
        shippingAddress {
          firstName
          lastName
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
    }
  }
  ${CART_AMOUNTS_FRAGMENT}
`;
